import { graphql } from 'react-relay';

export const baseDataEquityFragment = graphql`
    fragment BaseDataEquity_content on BaseDataEquity {
        currency
        value
        text
        datetext
        date
    }
`;
